import moment from 'moment';

export const FORMATO_HORA_12 = '12h';
export const FORMATO_HORA_24 = '24h';
export const STORAGE_KEY_FORMATO_HORA = 'kadosh_formato_hora_citas';

export function normalizarFormatoHora(valor) {
  return valor === FORMATO_HORA_24 ? FORMATO_HORA_24 : FORMATO_HORA_12;
}

export function guardarFormatoHoraLocal(formato) {
  try {
    localStorage.setItem(STORAGE_KEY_FORMATO_HORA, normalizarFormatoHora(formato));
  } catch (_) {
    /* ignore */
  }
}

export function leerFormatoHoraLocal() {
  try {
    return normalizarFormatoHora(localStorage.getItem(STORAGE_KEY_FORMATO_HORA));
  } catch (_) {
    return FORMATO_HORA_12;
  }
}

/** Formatea hora para el calendario de citas (columna lateral y slots). */
export function formatHoraCalendario(date, formato) {
  const fmt = normalizarFormatoHora(formato || leerFormatoHoraLocal());
  const m = moment(date);
  if (fmt === FORMATO_HORA_24) {
    return m.format('HH:mm');
  }
  return m.format('h:mm A');
}

export default formatHoraCalendario;
